import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ThirdPartyTracingActionExpiration } from '../../../../../../models/thridparty-tracingaction-expiration';
import { ThirdPartyTracingActionListItem } from '../../../../../../models/thirdparty-tracingaction-listitem';
import { Guid } from "guid-typescript";
import { ThirdPartyEvaluationService } from '../../../../../../services/thirdparty-evaluation.service';
import { BehaviorSubject } from 'rxjs';
import { ISelectionItem } from '../../../../../../models/selection-item';
import { ExternalRequestManagerService } from '../../../../../../services/external-request-manager.service';

@Component({
  selector: 'kt-addtask-dialog',
  templateUrl: './addtask-dialog.component.html',
  styleUrls: ['./addtask-dialog.component.scss']
})
export class AddtaskDialogComponent implements OnInit {
  pageLoading$: BehaviorSubject<boolean>;

  newTracingActionForm: FormGroup;
  maxLength: number = 255;

  expirationDateDataSource$: BehaviorSubject<ThirdPartyTracingActionExpiration[]>;
  responsableRoles$: BehaviorSubject<ISelectionItem[]> = new BehaviorSubject([]);

  constructor(
    private _evaluationsService: ThirdPartyEvaluationService,
    private _requestManager: ExternalRequestManagerService,
    public dialogRef: MatDialogRef<AddtaskDialogComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data?: ThirdPartyTracingActionListItem,
  ) {
    this.expirationDateDataSource$ = new BehaviorSubject<ThirdPartyTracingActionExpiration[]>([]);
    this.pageLoading$ = new BehaviorSubject<boolean>(true);
  }

  ngOnInit() {
    // Check for data loaded
    this.pageLoading$ = this._requestManager.requestPending$;

    this._requestManager.triggerRequest(this._evaluationsService.getTracingActionExpirationTypes(), {
      next: x => this.expirationDateDataSource$.next(x)
    });
    this._requestManager.triggerRequest(this._evaluationsService.getAvailableRoles(), {
      next: x => this.responsableRoles$.next(x)
    });

    var form = {
      newAction: [
        { value: this.data ? this.data.description : '', disabled: false },
        [Validators.required, Validators.maxLength(this.maxLength)]
      ],
      expirationDate: [
        { value: this.data ? this.data.expirationType.id : null, disabled: false },
        [Validators.required, Validators.maxLength(this.maxLength)]
      ],
      responsableRoleId: [
        { value: this.data ? this.data.roleId : null, disabled: false },
        [Validators.required]
      ],
    };

    this.newTracingActionForm = this.fb.group(form);
  }

  getTracingAction(): ThirdPartyTracingActionListItem {
    var expirationType = this.expirationDateDataSource$.getValue().find(x => x.id == this.newTracingActionForm.value.expirationDate);
    var remainingDays = expirationType.daysRemaining;

    var expirationDate = new Date(new Date().getTime() + remainingDays * 24 * 60 * 60 * 1000);

    return {
      id: this.data ? this.data.id : Guid.create(),
      description: this.newTracingActionForm.value.newAction,
      custom: true,
      active: true,
      expirationDate: expirationDate,
      expirationType: expirationType,
      roleId: this.newTracingActionForm.value.responsableRoleId,
      roleDescription: this.responsableRoles$.getValue()
        .find(x => x.id == this.newTracingActionForm.value.responsableRoleId)
        .description,
      canBeReUsed: false,
    };
  }

}
